import { createReducer } from "../../../common/reduxUtil";
import {
  GMAT_SET_CATALOG,
  GMAT_SET_LOAD_ERROR,
  GMAT_MARK_LESSON_COMPLETE,
} from "./types";

const initialState = {
  catalog: null,
  loadError: "",
};

export default createReducer(initialState, {
  [GMAT_SET_CATALOG]: (state, catalog) => ({ ...state, catalog }),
  [GMAT_SET_LOAD_ERROR]: (state, loadError) => ({ ...state, loadError }),
  // Only the catalogue the lesson was read in; a newer bundle keeps its own progress.
  [GMAT_MARK_LESSON_COMPLETE]: (state, { id, bundleId }) =>
    state.catalog?.bundleId === bundleId
      ? {
          ...state,
          catalog: {
            ...state.catalog,
            lessons: state.catalog.lessons.map((lesson) =>
              lesson.id === id ? { ...lesson, completed: true } : lesson
            ),
          },
        }
      : state,
});
